export class CountTranslation {
    one: string;
    few: string;
    many: string;
}

export enum CountTranslationValues {
    ONE = "ONE",
    FEW = "FEW",
    MANY = "MANY",
}

